import { ConfigurationStepForm } from '../../../schemas/configurationStepSchema';
import {
  CreateOrUpdateProgramPayload,
  ProgramFeatureName,
} from '../../../types/program';

export const getConfigurationProgramPayload = (
  fields: ConfigurationStepForm
): Partial<CreateOrUpdateProgramPayload> => {
  const totalDurationInDays =
    fields.totalDurationInDays * (fields.durationMeasure || 1);

  const features = [
    {
      name: ProgramFeatureName.IsRecommendQuiz,
      value: String(fields.isRecommendQuiz),
    },
    {
      name: ProgramFeatureName.ShowInSearch,
      value: String(fields.showInSearch),
    },
    { name: ProgramFeatureName.HasAccessory, value: String(fields.accessory) },
    {
      name: ProgramFeatureName.TrainingDaysAvailable,
      value: fields.trainingDaysAvailable,
    },
    { name: ProgramFeatureName.ForMother, value: fields.forMothers },
    { name: ProgramFeatureName.DurationProgram, value: fields.durationValue },
    { name: ProgramFeatureName.Gender, value: fields.gender },
  ];

  return {
    averageContentTimeInMinutes: fields.averageContentTimeInMinutes,
    totalDurationInDays,
    objectives: [{ id: fields.objectiveId, order: 1 }], // 1: primary, 2: secondary
    categoryIds: [fields.categoryId],
    levelIds: [fields.levelId],
    modalityIds: fields.modalityIds,
    tagNames: fields.tags || [],
    features,
  };
};
